import React from 'react';
import styled from 'styled-components';

// Chat icon SVG component
const ChatIcon = () => (
  <svg className="chat-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"
      fill="currentColor"
    />
    <path d="M7 9H17V11H7V9ZM7 12H15V14H7V12Z" fill="currentColor" />
  </svg>
);

// Styled button component
const ChatButton = styled.button`
  position: fixed;
  bottom: 40px;
  right: 90px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #1f2937;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  z-index: 1000;
  color: #ffffff;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  .chat-icon {
    width: 24px;
    height: 24px;
    color: #ffffff;
    fill: #ffffff;
  }

  @media (max-width: 480px) {
    bottom: 64px;
    right: 72px;
    width: 52px;
    height: 52px;
    .chat-icon {
      width: 20px;
      height: 20px;
    }
  }
`;

interface IntercomChatButtonProps {
  onClick?: () => void;
}

const IntercomChatButton: React.FC<IntercomChatButtonProps> = ({ onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (window.Intercom) {
      window.Intercom('show');
    }
  };

  return (
    <ChatButton onClick={handleClick} className="intercom-chat-button">
      <ChatIcon />
    </ChatButton>
  );
};

export default IntercomChatButton;
